<template>
  <div class="accordion">
    <!-- Toggle Button for the entire block -->
    <p class="accordion-header" @click="toggle">
      {{ t('Equations') }} <span v-if="isOpen">{{ t('minusSign') }}</span><span v-else>{{ t('plusSign') }}</span>
    </p>

    <!-- Content -->
    <div v-show="isOpen" class="accordionContent">
      <div v-for="equation in equations" :key="equation" class="equation">
        <pre>{{ equation }}</pre>
      </div>
    </div>
  </div>
</template>

<script>
import { ref,reactive } from 'vue';
import { useI18n } from 'vue-i18n';

export default {
  name: 'EquationBlock',
  props: {
    equations: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  setup() {
    const isOpen = ref(false);

    const { t } = useI18n();

    // Create a reactive object with a function
    const translations = reactive({
      t: (key) => t(key)
    })

    const toggle = () => {
      isOpen.value = !isOpen.value;
    };

    return { 
      t: translations.t,
      isOpen, toggle };
  },
}
</script>

<style>
.accordion-header {
  cursor: pointer;
  color:#198754;
  /* Add your styles for the header */
}
.accordion-content {
  /* Add your styles for the content */
  padding:10px;
}
.equation {
  /* Add your styles for each equation */
}
</style>
